<template>
    <div class="tool-content">
       
        <div class="left-tool">
            <!-- <span style="color:#fff">{{ pdfPageNow }}</span> -->
            <div class="tool-box">
                    <el-popover popper-class="peit_popver"
                placement="right"
                trigger="hover">
               <span class="label" >配套资源管理</span>
               <div class="tool-item" slot="reference"  @click="viewSupporting(1)">
                    <i class="iconfont">&#xe74d;</i>
                </div>
                </el-popover>
                <el-popover popper-class="peit_popver"
                placement="right"
                trigger="hover">
               <div  style="cursor: pointer;">添加录音</div>
               <div class="tool-item" slot="reference" @click="addTool('1')">
                    <i class="iconfont">&#xe6c1;</i>
                </div>
                </el-popover>
                <el-popover popper-class="peit_popver"
                placement="right"
                trigger="hover">
               <div  style="cursor: pointer;">添加链接</div>
               <div class="tool-item" slot="reference" @click="addTool('2')">
                    <i class="iconfont">&#xe66e;</i>
                </div>
                </el-popover>
                <el-popover popper-class="peit_popver"
                placement="right"
                trigger="hover">
               <div  style="cursor: pointer;">添加配套材料</div>
               <div class="tool-item" slot="reference" @click="addTool('3')">
                    <i class="iconfont">&#xe74b;</i>
                </div>
                </el-popover>
                
                
            </div>
        </div>




        <!--添加工具弹窗-->
        <el-dialog :visible.sync="addToolDialog" width="56%" @close="resetAddToolForm()"
                   :close-on-click-modal="false"  append-to-body top="10vh">
            <div class="dialog-header" slot="title">
                <span class="left">{{dialog_title}}</span>
                <!-- <span class="center" v-if="dialog_title === '添加配套材料'">{{course_name}}第{{zhangIndex+1}}章第{{jieIndex+1}}节</span> -->
            </div>
            <div class="dialog-content">
                <div class="content-item recording-item" v-if="dialog_title === '添加录音'">
                    <el-form :model="recordingForm" ref="recordingForm" :rules="recordingRules" label-position="center"
                             class="info-form">
                        <el-form-item label="录音名称：" :label-width="recordingFormLabelWidth" prop="tag_name">
                            <el-input v-model="recordingForm.tag_name"  placeholder="请输入录音名称3-10个字"
                                      class="app-input"></el-input>
                        </el-form-item>
                        <el-form-item label="上传录音：" :label-width="recordingFormLabelWidth" prop="recording"
                                      class="el-form-item-logo">
                            <div class="upload-cover">
                                <i class="iconfont">&#xe752;</i>
                                <span class="upload-text">{{recordingForm.recording ? '重新上传' : '点击上传'}}</span>
                            </div>
                            <input type="file" accept="*" title="" ref="alogo" @change="changeEditRecording($event)"
                                   class="cover-input">
                            <div class="up-img-show" v-show="videoName">
                                <i class="el-icon-document"></i>
                                <span style="margin-left: 5px;">{{videoName}}</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content-item recording-item" v-if="dialog_title === '添加链接'">
                    <el-form :model="linkForm" ref="linkForm" :rules="linkRules" label-position="center"
                             class="info-form">
                        <el-form-item label="名称：" :label-width="recordingFormLabelWidth" prop="link_name">
                            <el-input v-model="linkForm.link_name" autocomplete="off" placeholder="请输入名称3-10个字"
                                      class="app-input"></el-input>
                        </el-form-item>
                        <el-form-item label="链接：" :label-width="recordingFormLabelWidth" prop="link_url">
                            <el-input v-model="linkForm.link_url" autocomplete="off" placeholder="请输入链接"
                                      class="app-input"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content-item resources-item" v-if="dialog_title === '添加配套材料'">
                    <div class="select type-list">
                        <span class="select-text">类型：</span>

                        <!-- <el-radio-group v-model="typeValve"  @input="selectType1">
                            <el-radio   v-for="item in typeList" :label="item.id">{{ item.name }}</el-radio>
                        </el-radio-group> -->
                       
                        <span v-for="item in typeList" style="margin-left: 24px; color: #333; cursor: pointer;" :style="{ color: typeValve === item.id? '#006EFF' : '' }" @click="selectType1(item.id)">{{ item.name }}</span>
                 
                    </div>
                    <div class="content">
                        
                        <div class="right-list">
                            <div v-if="typeChildLists.length==0" class="no-data">
                               <img src="../../assets/images/no-data.png" alt="">
                            </div>
                            <div v-else> 
                                <div v-if="suffix=='avi' || suffix=='mp4'" :style="suffix == 'avi' || suffix == 'mp4' ? { display: 'flex', 'align-items': 'center','background-color':'#000000' } : ''" class="avi-box">
                                <video ref="addVideo" :src="`${material_content}`" autoplay controls  width="100%" height="100%"
                                    class="iframe-content">
                                </video>
                            </div>
                            <div v-else-if="suffix=='pdf'" style="height:100%">
                                <iframe :src="material_content" width="100%" height="100%"
                                    class="iframe-content"></iframe>
                            </div>
                            <div v-else  class="download_box">
                               <img src="@/assets/images/no-file.png" alt="">
                               <p>{{ material_content_name+suffix }}   <i class="iconfont" style="color: #006EFF; cursor: pointer; margin-left: 12px;"  @click="adddownload" >&#xe6be;</i></p>
                            </div>
                            <div class="quanping" v-if="suffix=='pdf'" @click="addallQueern">
                            <i class="iconfont">&#xe7cf;</i>
                            <p>全屏</p>
                           </div>
                        </div>
                    </div>
                    <el-scrollbar class="left-list" style="margin-left:-13px ;" :native="false">
                        <div class="type-item"
                                 v-for="item in typeChildLists"
                                 :title="item.title"
                                 >
                                 <i class="iconfont" style="color: #006EFF; margin-right: -5px;" v-if="currentItem === item.id">&#xe7ad;</i>
                              <div class="type_name" :class="{current: currentItem === item.id}" @click="selectTypeChild(item)">
                                {{item.title}}
                              </div>
                             
                                <i v-if="item.is_add==0" class="el-icon-circle-plus add_icon"  style="color: #666666; font-size:18px" @click="add_ziyuan(item)"></i> 
                                <i v-else class="el-icon-remove add_icon"  style="color:#FF3838; font-size:18px" @click="delete_ziyuan(item)"></i> 
                                <!-- el-icon-remove-outline -->
                             
                            </div>
                            <div v-if="typeChildLists.length === 0" class="no-data">
                                <span>暂无数据</span>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="resetAddToolForm()" class="dialog-footer-btn1">取 消</el-button>
                <el-button  type="primary" v-if="dialog_title === '添加录音'" @click="submitAddTool(1)"
                           class="dialog-footer-btn">添加
                </el-button>
                <el-button  type="primary" v-if="dialog_title === '添加链接'" @click="submitAddTool(2)"
                           class="dialog-footer-btn">添加
                </el-button>
                <el-button  type="primary" v-if="dialog_title === '添加配套材料'" @click="submitAddMaterial(3)"
                           class="dialog-footer-btn">添加
                </el-button>
            </div>
        </el-dialog>



        <!-- 配套资源管理弹框 -->
        <el-dialog
        title="查看内容"
        :visible.sync="supportingResourcesVisible"
        width="56%"
        :before-close="handleSupportingClose" top="10vh">
        <div class="supporting-box">
            <div class="header">
                <span>选择内容:</span>
                <el-radio-group v-model="selectRadio"  @input="getSelectRadio">
                    <el-radio :label="1">录音</el-radio>
                    <el-radio :label="2">链接</el-radio>
                    <el-radio :label="3">配套材料</el-radio>
                </el-radio-group>

            </div>
        <el-scrollbar>
            <div class="show-box" v-if="selectRadio==1">
                <!-- <audioModule audioName="录音1" audioSrc="uploads/course/courseWare/record/20240703/abe43d69ff3a3412018561fcceb33616.mp3"/> -->
                <div v-for="item in recordingList" class="audio_item">
                    <audioModule :audioName="item.data.name" :audioSrc="item.data.url.url"/>
                    <div class="delete_audio_btn" @click="del(item.id)" ><i class="el-icon-delete" style="display: inline-block;line-height:0px;"></i></div>
                        
                </div>
                <div v-if="recordingList.length==0"  class="nodata">
                    <img src="../../assets/images/no-data.png" alt="">
                
                </div>
            </div>
        </el-scrollbar>
        <el-scrollbar>
            <div class="show-box" v-if="selectRadio==2">
                <div class="link_box">
                    <div class="link_item" v-for="item in linkList" >
                        <div class="item">
                            <p class="link_name">{{ item.data.name }}</p>
                            <a  class="link_url" style="color: #8F8F8F;" :href="item.data.url" target="_blank"><span class="url">{{item.data.url}}</span></a>

                        </div>
                        <div class="delete_audio_btn" @click="del(item.id)" ><i class="el-icon-delete" style="display: inline-block;line-height:0px;"></i></div>
                    </div>
                   
                </div>
                <div v-if="linkList.length==0"  class="nodata">
                    <img src="../../assets/images/no-data.png" alt="">
                
                </div>
                

            </div>
        </el-scrollbar>
       
            <div class="show-box" v-if="selectRadio==3">
                <div class="content-item resources-item resource_box" >
                    <div class="select type-list">
                        <span class="select-text">类型：</span>
                        <span v-for="item in typeList" style="margin-left: 24px; color: #333; cursor: pointer;" :style="{ color: typeValve === item.id? '#006EFF' : '' }" @click="selectType(item.id)">{{ item.name }}</span>
                    </div>
                    <div class="content">
                       
                        <div class="right-list" :style="suffix == 'avi' || suffix == 'mp4' ? { display: 'flex', 'align-items': 'center','background-color':'#000000' } : ''">
                            <div v-if="addedMaterialLists.length==0" class="no-data">
                                <!-- <span>暂无数据</span> -->
                                <img src="../../assets/images/no-data.png" alt="">
                            </div>
                           <div v-else>
                            <div v-if="suffix=='avi' || suffix=='mp4'" class="avi-box">
                                <video ref="video" v-if="addedMaterialLists.length > 0" :src="`${added_material_content}`" autoplay controls  width="100%" height="100%"
                                    class="iframe-content">
                                </video>
                            </div>
                            <div v-else-if="suffix=='pdf'" style="height:100%">
                                <iframe v-if="addedMaterialLists.length > 0" :src="`${added_material_content}`" width="100%" height="100%"
                                    class="iframe-content">
                                </iframe>
                            </div>
                            <div v-else  class="download_box">
                               <img src="@/assets/images/no-file.png" alt="">
                               <p>{{ material_content_name+suffix }}   <i class="iconfont" style="color: #006EFF; cursor: pointer; margin-left: 12px;"  @click="download" >&#xe6be;</i></p>
                            </div>  
                           </div>
                           <div class="quanping" v-if="suffix=='pdf'" @click="allQueern">
                            <i class="iconfont">&#xe7cf;</i>
                            <p>全屏</p>
                           </div>
                        </div>
                        <el-scrollbar class="left-list"  :native="false">
                            <div class="type-item"
                                 v-for="item in addedMaterialLists"
                                
                                 :title="item.data.title"
                                 @click="selectTypeMaterial(item)">
                                <i class="iconfont" style="color: #006EFF;margin-right: -5px; " v-if="currentItem === item.data.material_id">&#xe7ad;</i>
                                <div class="type_name"  :class="{current: currentItem === item.data.material_id}">
                                    {{item.data.title}}
                                </div>
                                <i  class="el-icon-remove add_icon"  style="color:#FF3838; font-size:18px" @click="del(item.id)"></i> 
                                <!-- el-icon-remove-outline -->
                            </div>
                            <div v-if="addedMaterialLists.length === 0" class="no-data">
                                <span>暂无数据</span>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
                
            </div>
       
            
            
           
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="dialog-footer-btn1" @click="handleSupportingClose">取 消</el-button>
            <el-button class="dialog-footer-btn" type="primary" @click="supportingResourcesVisible = false">确 定</el-button>
        </span>
        </el-dialog>

    </div>
</template>

<script>
import audioModule from './audioModule.vue';
    export default {
        name: "WareTool",
        props: ['resource_id','course_name','zhangIndex','jieIndex',"pdfPageNow"],
        data() {
            return {
                course_id: '',
                //弹窗位置
                pop_up_position: 'bottom-start',
                //添加工具弹窗标题
                dialog_title: '',
                //是否显示添加弹窗
                addToolDialog: false,
                //选中的类型
                typeValve: 999,
                //类型类表
                typeList: [],
                typeChildLists: [],
                material_content: '',
                currentItem: '1',
                //已添加的配套材料列表
                addedMaterialLists: [],
                added_material_content: '',
                //录音表单数据
                recordingForm: {
                    tag_name: '',
                    recording: ''
                },
                recordingRules: {
                    tag_name: [
                        {required: true, message: '请输入标签3-10个字', trigger: 'blur'},
                        {min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur'}
                    ]
                },
                recordingFormLabelWidth: '120px',
                recordingFile: '',
                //链接表单数据
                linkForm: {
                    link_name: '',
                    link_url: ''
                },
                linkRules: {
                    link_name: [
                        {required: true, message: '请输入标签3-10个字', trigger: 'blur'},
                        {min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur'}
                    ],
                    link_url: [
                        {required: true, message: '请输入链接', trigger: 'blur'},
                        {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
                    ]
                },
                //是否显示查看
                viewToolDialog: false,
                //查看工具弹窗标题
                dialog_view_title: '',
                //选中的录音
                recordingValve: '',
                recordingUrl: '',
                recordingId: '',
                //录音列表
                recordingList: [],
                //选中的链接
                linkValve: '',
                linkUrl: '',
                linkId: '',
                //链接列表
                linkList: [],
                videoName: '',
                videoPath: [],
                //配套材料-暂无数据
                is_no_data: false,
                resId:void 0,
                suffix:'',
                supportingResourcesVisible:false,//配套资源弹框,
                selectRadio:1,
                supportimgArray:[],//添加多个配套材料,
                material_content_name:""
            }
        },
        mounted() {
            this.course_id = this.$route.query.course_id;
            this.getTypeList();
        },
        methods: {
            changeMessage(){
                this.$forceUpdate()
            },
            getTypeList() {
                this.$thttp.axiosGet(this.$api.meterial_mtlTypeList, (res) => {
                    if (res.code === 200) {
                        this.typeList = res.data;
                        let obj = {
                            id: 999,
                            name: '全部',
                            type: 0
                        }
                        this.typeList.splice(0, 0, obj);
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //选择要添加的工具
            addTool(command) {
                this.$emit("getPdfPage")
               
                if (command === '1') {
                    this.dialog_title = '添加录音';
                    this.recordingForm.tag_name='';
                    this.recordingForm.recording=""
                    this.videoName=""
                }
                if (command === '2') {
                    this.dialog_title = '添加链接';
                }
                if (command === '3') {
                    this.dialog_title = '添加配套材料';
                   
                    this.getMaterialList();
                    // this.getCourseWare(3)
                   
                   
                }
                this.addToolDialog = true;
            },
            //选中的类型
            selectType(val) {
                console.log(val)
                this.typeValve = val;
                this.getCourseWare(3)
                // this.getMaterialList();
                // if (this.typeValve === 999) {
                //     this.getAllCourseWare();
                // } else {
                //     this.getCourseWare(3);
                // }
            },
            selectType1(val){
                this.typeValve=val
                this.getMaterialList();
            },
            selectTypeChild(item) {
                // this.typeValve=item.material_type_id?item.material_type_id:item.meterial_type_id
                this.resId=item.resource_id?item.resource_id:void 0
                this.currentItem = item.id;
                this.getMaterialContent(item.id);
            },
            selectShowType(val) {
                if (val === 999) {
                    this.getAllCourseWare();
                } else {
                    this.getCourseWare(3);
                }
            },
            selectTypeMaterial(item) {
                console.log(item)
                this.currentItem = item.data.material_id;
                this.getAddedMaterialContent(item.data.material_id);
            },
            openPerson(item) {
                this.currentItem = item.id;
                this.person_view_url = item.file_path.src;
            },
            //上传录音
            changeEditRecording(event) {
                let modelName = event.target.files[0].name;
                let limiteFileType = ["mp3", 'wav', 'midi', 'ogg', 'vqf'];
                if (
                    !limiteFileType.includes(
                        modelName.split(".")[modelName.split(".").length - 1].toLowerCase()
                    )
                ) {
                    this.$message.warning("文件格式错误！");
                    return;
                }
                let fileList = event.target.files[0];
                let formData = new FormData();
                formData.append("file", fileList);
                this.$thttp.axiosPost(this.$api.courseware_uploadWareFiles, formData, (res) => {
                    if (res.code === 200) {
                        this.videoName = modelName;
                        this.videoPath.push(res.data.url);
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    this.$message.error("文件上传失败")
                    reject(err)
                })
            },
            //重置弹窗
            resetAddToolForm() {
                this.addToolDialog = false;
                this.typeValve = 999;
                this.linkForm.link_name = '';
                this.linkForm.link_url = '';
                this.recordingForm.tag_name = '';
                this.recordingForm.recording = '';
                this.videoName=""
              
                if(this.$refs.addVideo){
                    this.$refs.addVideo.pause()
                }
             
               
            },
            //查看工具弹窗
            viewRecording() {
                this.viewToolDialog = true;
                this.dialog_view_title = '录音';
                this.getCourseWare(1);
            },
            viewLink() {
                this.viewToolDialog = true;
                this.dialog_view_title = '链接';
                this.getCourseWare(2);
            },
            viewResources() {
                this.viewToolDialog = true;
                this.dialog_view_title = '配套材料';
                if (this.typeValve === 999) {
                    this.getAllCourseWare();
                } else {
                    this.getCourseWare(3);
                }
            },
            oneMaterial() {
                this.$thttp.axiosGet(this.$api.meterial_showMeterialList, (res) => {
                    if (res.code === 200) {
                        if (res.data.data.length > 0) {
                            this.is_no_data = false;
                            this.typeChildLists = res.data.data;
                            console.log("333333333333333333");
                            this.currentItem = res.data.data[0].id;
                            this.getMaterialContent(res.data.data[0].id);
                        } else {
                            this.is_no_data = true;
                        }
                    }
                }, (err) => {
                    this.$common.axiosErrorMsg(err);
                })
            },
            getCourseWare(type) {
                let param = {
                    resource_id: this.resource_id,
                    type: type,
                    show: 'all',
                    resource_page:this.pdfPageNow
                }
                if (type === 3 && this.typeValve!=999) {
                    param.material_type_id = this.typeValve;
                }
                this.$thttp.axiosGetBy(this.$api.courseware_showCourseWare, param, (res) => {
                    if (res.code === 200) {
                        if (type === 1) {
                            this.recordingList = res.data;
                            if (res.data.length > 0) {
                                this.recordingValve = res.data[0].id;
                                this.recordingUrl = res.data[0].data.url.url;
                                this.recordingId = res.data[0].id;
                            }
                        } else if (type === 2) {
                            this.linkList = res.data;
                            if (res.data.length > 0) {
                                this.linkValve = res.data[0].id;
                                this.linkUrl = res.data[0].data.url;
                                this.linkId = res.data[0].id;
                            } else {
                                this.linkList = [];
                                this.recordingValve = '';
                            }
                        } else {
                            this.addedMaterialLists = res.data;
                            console.log(this.addedMaterialLists,"ressssssssssss");
                            res.data.forEach(item=>{
                                item.data.material_id=item.data.material_id?item.data.material_id:item.data.resource_id
                            })
                            if (res.data.length > 0) {
                                this.is_no_data = false;
                                this.currentItem = res.data[0].data.material_id;
                                this.getAddedMaterialContent(res.data[0].data.material_id);
                            } else {
                                this.is_no_data = true;
                            }
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //获取所有配套材料
            getAllCourseWare() {
                let param = {
                    resource_id: this.resource_id,
                    type: 3,
                    show: 'all',
                    
                }
                this.$thttp.axiosGetBy(this.$api.courseware_showCourseWare, param, (res) => {
                    if (res.code === 200) {
                        this.addedMaterialLists = res.data;
                        if (res.data.length > 0) {
                            this.is_no_data = false;
                            this.currentItem = res.data[0].data.material_id;
                            this.getAddedMaterialContent(res.data[0].data.material_id);
                        } else {
                            this.is_no_data = true;
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            handleCloseTool() {
                this.recordingList = [];
                this.linkList = [];
                this.recordingUrl = '';
                this.recordingId = '';
                this.linkUrl = '';
                this.linkId = '';
                this.recordingValve = '';
                this.linkValve = '';
                this.typeValve = 999;
            },
            //选中的录音
            selectRecording(val) {
                this.recordingList.forEach(item => {
                    if(item.id === val){
                        this.recordingUrl = item.data.url.url;
                        this.recordingId = item.id;
                    }
                })
                if(val === ''){
                    this.recordingUrl = '';
                    this.recordingId = '';
                }
            },
            //选中的链接
            selectLink(val) {
                this.linkList.forEach(item => {
                    if(item.id === val){
                        this.linkUrl = item.data.url;
                        this.linkId = item.id;
                    }
                })
                if(val === ''){
                    this.linkUrl = '';
                    this.linkId = '';
                }
            },
            //获取配套材料列表
            getMaterialList() {
                let param = {
                    course_id: this.$route.query.course_id,
                    course_chapter: this.zhangIndex,
                    course_node: this.jieIndex,
                    type: 'all',
                    resource_page:this.pdfPageNow,
                    resource_id: this.resource_id,
                }
                if (this.typeValve !== 999) {
                    param.meterial_type_id = this.typeValve;
                }
                this.$thttp.axiosGetBy(this.$api.meterial_showMeterialList, param, (res) => {
                    if (res.code === 200) {
                        // this.supportimgArray=[]
                        this.typeChildLists = res.data;
                        console.log("11111111111111");
                        if (res.data.length > 0) {
                            this.is_no_data = false;
                            this.currentItem = res.data[0].id;
                            this.getMaterialContent(res.data[0].id);
                        } else {
                            this.is_no_data = true;
                        }
                      if(this.typeValve==999){
                        this.supportimgArray=[]
                        this.typeChildLists.forEach(item=>{
                            if(item.is_add==1){
                                let obj={
                                    material_type_id:item.material_type_id,
                                    resource_id:item.resource_id || item.id
                                }
                                this.supportimgArray.push(obj)
                            }
                        })
                        console.log( this.supportimgArray,"进入的时候获取的数据");
                      }
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //获取配套材料对应资源
            getMaterialContent(id) {
                this.typeChildLists.forEach((item) => {
                    if (item.id === id) {
                        this.material_content = item.file_preview_path.url?item.file_preview_path.url:item.file_preview_path;
                        // this.suffix=this.material_content.substring(this.material_content.lastIndexOf('.')+1)
                        this.suffix=item.resource_file_type
                        this.material_content_name=item.file_name || item.title
                      
                        console.log(item,"文件类型");
                    }
                })
            },
            //获取已添加对的配套材料对应资源
            getAddedMaterialContent(id) {
                this.addedMaterialLists.forEach((item) => {
                    console.log("查看已经添加的配套材料",item);
                    if (item.data.material_id === id) {
                        this.added_material_content = item.data.file_preview_path.url?item.data.file_preview_path.url:item.data.file_preview_path;
                        this.suffix=item.data.resource_file_type
                        this.material_content_name=item.file_name || item.data.title
                    }
                    // this.suffix=this.added_material_content.substring(this.added_material_content.lastIndexOf('.')+1)
                    
                })
            },
            //添加
            submitAddTool(type) {
                let obj = {};
                switch (type) {
                    case 1:
                        if (this.videoPath.length === 0) {
                            this.$message.warning('请上传文件！')
                            return
                        }
                        obj.name = this.recordingForm.tag_name;
                        obj.url = this.videoPath[0];
                        break;
                    case 2:
                        obj.name = this.linkForm.link_name;
                        let url = this.linkForm.link_url;
                        let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/&&&])+$/;
                        if (!reg.test(url)) {
                            this.$message.warning("这网址不是以http://https://开头，或者不是网址！");
                            return;
                        }
                        obj.url = this.linkForm.link_url;
                        break;
                }
                let param = {};
                param.data = JSON.stringify(obj);
                param.resource_id = this.resource_id;
                param.type = type;
                param.page=this.pdfPageNow
                this.$thttp.axiosPost(this.$api.courseware_saveCourseWare, param, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.resetAddToolForm();
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    this.$message.error("文件上传失败")
                    reject(err)
                })
            },
            //添加配套材料
            submitAddMaterial(type) {
                
                console.log(this.supportimgArray,"添加资源的数组");
                let param = {};
                param.data = this.supportimgArray;
                param.resource_id = this.resource_id;
                param.type = type;
                param.page=this.pdfPageNow
                this.$thttp.axiosPost(this.$api.courseware_saveCourseWares, param, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.resetAddToolForm();
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    this.$message.error(err);
                })
            },
            //删除图钉
            del(id) {
                this.$confirm('是否删除，删除完将无法恢复', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'blue-btn',
                    type: 'warning',
                }).then(() => {
                    this.$thttp.axiosGetBy(this.$api.courseware_delCourseWare, {id: id}, (res) => {
                        if (res.code === 200) {
                            // if (this.selectRadio === 1) {
                            //     this.getCourseWare(1);
                            // }
                            // if (this.selectRadio === 2) {
                            //     this.getCourseWare(2);
                            //     this.linkValve = '';
                            //     this.linkUrl = '';
                            // }
                            // if (this.selectRadio === '配套材料') {
                            //     this.getCourseWare(3);
                            // }
                            this.getCourseWare(this.selectRadio);
                            this.$message.success(res.msg);
                        } else {
                            this.$message.warning(res.msg);
                        }
                    }, (err) => {
                        console.log(err);
                    })
                }).catch(() => {
                    this.$message.info('已取消删除');
                })
            },

            handleSupportingClose(){
                // console.log(this.$refs.video,"视频");
                
                if(this.$refs.video){
                    this.$refs.video.pause()
                }
              
                this.supportingResourcesVisible=false
                this.typeValve=999
                this.selectRadio=1
               
            },
            viewSupporting(index){
                this.$emit("getPdfPage")
               this.supportingResourcesVisible=index==1?true:false 
               this.typeValve=999
               this.getCourseWare(1);

            },
            getSelectRadio(val){
                // console.log(this.selectRadio,"选择的内容");
                // 查看内容  1代表着  录音;  2 代表 链接 ; 3代表  配套材料
                 this.getCourseWare(val);

            },
            add_ziyuan(val){
        //    console.log(this.currentItem,this.typeChildLists,val,"添加");
                this.typeChildLists.forEach(item=>{
                    if(item.resource_id){
                         if(item.material_type_id==val.material_type_id && (item.resource_id==val.resource_id )){
                        item.is_add=1
                    }
                    }else{
                        if(item.material_type_id==val.material_type_id && (item.id==val.id )){
                        item.is_add=1
                    } 
                    }
                })
                console.log(this.supportimgArray,"数据添加之前的数据");
                console.log("val",val);
                let obj={
                    material_type_id:val.material_type_id,
                    resource_id:val.resource_id ||val.id
                }
                let index=this.supportimgArray.findIndex(item=>item.resource_id==obj.resource_id)
                if(index==-1){
                    this.supportimgArray.push(obj)
                }
                console.log(this.supportimgArray,"数据添加之后");
            

            },
            delete_ziyuan(val){
                this.typeChildLists.forEach(item=>{
                    if(item.resource_id){
                        if(item.material_type_id==val.material_type_id && item.resource_id==val.resource_id){
                            item.is_add=0
                        }
                    }else{
                        if(item.material_type_id==val.material_type_id && item.id==val.id){
                            item.is_add=0
                        }
                    }

                    
                })
                let index=this.supportimgArray.findIndex(item => item.material_type_id==val.material_type_id && (item.resource_id==val.resource_id || item.resource_id==val.id))
                this.supportimgArray.splice(index,1)

            },
            adddownload(){
                window.open(this.material_content);
            },
            // 下载文件
            download(){
                window.open(this.added_material_content);
            },
            allQueern(){
                window.open(this.added_material_content,"_blank");
            },
            addallQueern(){
                window.open(this.material_content,"_blank")
            }
        },
        components:{
            audioModule
        }
    }
</script>

<style scoped lang="scss">

    .left-tool {
        position: absolute;
        z-index: 999;
        width: 80px;
        /*height: calc(100% - 150px);*/
        height: calc(100% - 34px);
        // background-color: #333;
        /*right: 100px;*/
        left: 0;
        top: 36px;
        padding-top: 80px;
        box-sizing: border-box;
        // background-color: pink;
        .tool-box{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: flex-end;
            // background-color: skyblue;
            padding-bottom: 40px;
            padding-left: 24px;
            box-sizing: border-box;
        }

    
    }
    .label{
        width: 100px !important;
        cursor: pointer;
    }
    .tool-item {
           width: 48px;
           height: 48px;
           background-color: #FFFFFF;
           border-radius: 24px;
           display: flex;
           align-items: center;
           justify-content: center;
           margin-top: 20px;
           cursor: pointer;
           border: 1px solid #e4e4e4;
        //    box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08);
        box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);
           .iconfont{
            color: #000000;
            font-size: 22px;
           }
        }
   
    .add-tool-dialog {
        ::v-deep .el-dialog {
            border-radius: 6px;
            .el-dialog__close {
                color: #fff;
            }
        }

        ::v-deep .el-dialog__header {
            padding: 15px 20px;
            color: #fff;
            font-size: 16px;
            background-color: #409EFF;
            border-radius: 6px 6px 0 0;

            .dialog-header {
                display: flex;
                position: relative;

                .center {
                    position: absolute;
                    display: inline-block;
                    text-align: center;
                    width: 100%;
                }
            }

            ::v-deep .el-dialog__headerbtn .el-dialog__close {
                color: #fff;
            }
        }

        ::v-deep .el-dialog__body {
            /*height: 467px;*/
            padding: 0;

            .dialog-content {
                height: 100%;
                background-color: #F2F2F2;

                .content-item {
                    display: flex;
                    flex-direction: column;
                }

                .resources-item {
                    /*height: 467px;*/
                    /*height: 667px;*/
                    height: 500px;
                }

                .recording-item {
                    background-color: #fff;
                    height: 500px;
                }

                .view-recording-item {
                    height: 500px;

                    .content {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin-top: 13px;
                        background-color: #fff;
                        .recording-name {
                            height: 60px;
                        }
                    }
                }

                .view-link-item {
                    background-color: #fff;
                    height: 320px;

                    .content {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        background-color: #F2F2F2;
                        margin: 20px;
                    }
                }

                .type-list {
                    display: flex;
                    align-items: center;
                    height: 80px;
                    background-color: #fff;
                    padding: 0 20px;
                    .select-text{
                        width: 30px;
                        display: inline-block;
                    }
                }

                
            }
        }

        ::v-deep .el-dialog__footer {
            padding: 20px;

            .dialog-footer {
              
            }
        }
    }

    .info-form {
        padding: 30px;

        .el-form-item-logo {
            margin-bottom: 0;
        }

        .upload-cover {
            position: relative;
            background-color: #DCECFE;
            border-color: #DCECFE;
            padding: 0;
            width: 104px;
            height: 40px;
            background: #F6F6F6;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            border-radius: 4px;
            margin-top: 5px;

            i {
                width: 16px;
                height: 16px;
                line-height: 16px;
                margin-right: 10px;
            }

            span.upload-text {
                display: block;
                height: 100%;
                line-height: 40px;
            }
        }

        .cover-input {
            position: absolute;
            width: 100px;
            height: 30px;
            top: 0;
            opacity: 0;
            cursor: pointer;
        }

        .up-img-show {
            display: flex;
            // justify-content: center;
            align-items: center;
            position: absolute;
            width: 100%;
            height: 30px;
            top: 60px;
            left: 0px;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    .del-btn {
        padding: 2px 6px;
        background-color: #FF0000;
        border: 1px solid #FF0000;
        color: #fff;
        margin-right: 5px;
    }
    .other-content {
        position: relative;
        .del-btn {
            position: absolute;
            top: 14px;
            right: 10px;
        }
    }
   // 配套资源
.supporting-box{
    width: 100%;
    // height: 200px;
    // background-color: pink;
    .header{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        span{
            margin-right: 20px;
        }
    }
    .show-box{
        margin-top: 30px;
        height: 500px;
        .audio_item{
            display: flex;
            align-items: center;
            margin-top: 20px;
            padding-right: 14px;
            box-sizing: border-box;
            .delete_audio_btn{
                width: 20px;
                height: 20px;
                border-radius: 20px;
                background-color: #FF3838 ;
                margin-left: 20px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: center;
               
            }
        }
        .nodata{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .link_box{
            display: flex;
            align-items: center;
            margin-top: 20px;
            flex-wrap: wrap;
            .link_item{
                width: 258px;
                height: 96px;
                display: flex;
                margin-right: 12px;
                margin-bottom: 20px;
                align-items: center;
          
              
                .item{
                    width: 228px;
                    height: 87px;
                    background: #F2F6FA;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #E1E6F0;
                    padding: 0 10px;
                    box-sizing: border-box;
                    .link_name{
                        width: 200px;
                        white-space: nowrap; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                       
                        
                    }
                    .link_url{
                            color: #8F8F8F !important ;
                            .url{
                                width: 200px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: inline-block;
                                color: #8F8F8F !important ;
                            }
                        }
                }
                .delete_audio_btn{
                width: 20px;
                height: 20px;
                border-radius: 20px;
                background-color: #FF3838 ;
                margin-left: 10px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: center;
               
            }
                
            }

        }
        .resource_box{
            width: 100%;
            .content{
                  width: 100%;
                    display: flex;
                    height: 500px;
                    padding: 13px;
                    margin-top: 10px;
                    box-sizing: border-box;
                .left-list{
                    width: 240px;
                    height: 100%;
                    margin-left: -13px;
                    // background-color: pink;
                       
                    box-sizing: border-box;
                    overflow-x:hidden;
                  
                    .type-item {
                            width: 94%;
                            // margin: 10px;
                            height: 34px;
                            line-height: 34px;
                            // padding-left: 10px;
                            color: #333;
                            font-size: 14px;
                            cursor: pointer;
                            // background-color: pink;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            padding-right:20px;
                         
                            .type_name{
                                width: 180px;
                                // background-color: skyblue;
                                height: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                border: 1px solid #DDDDDD;
                                padding-left: 8px;
                                box-sizing: border-box;
                                border-radius: 4px;
                                &:hover {
                                background-color: #ECF5FF;
                                // color: #409EFF;
                            }
                            }
                            .add_icon{
                                margin-left: 10px;
                            }
                            .current {
                                background: #ECF5FF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #006EFF;
                        }
                        }
                }
                .right-list {
                    // 添加
                        flex: 1;
                        width: 0%;
                        // margin: 22px 22px 22px 35px;
                        margin-right: 14px;
                        box-sizing: border-box;
                        background: #F2F6FA;
                        // border-radius: 4px;
                        position: relative;
                       div{
                        .avi-box{
                        // width: 100%;
                        // height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                       }
                        // display: flex;
                        // align-items: center;
                        /*background-color: rebeccapurple;*/
                        .download_box{
                            width: 100%;
                            height: 100%;
                        
                            border: 10px soild #999999;
                            border-radius: 4px;
                        
                            display: flex;
                            align-items: center;
                            justify-content:center;
                            flex-direction: column;
                            
                        }
                       }
                       .quanping{
                        width: 66px;
                        height: 28px;
                        background: rgba(0,0,0,0.5);
                        border-radius: 4px 4px 4px 4px;
                        position: absolute;
                        bottom: -3px;
                        right: 20px;
                        display: flex;
                        align-items: center;
                        color: #FFFFFF;
                        justify-content:space-between;
                        padding: 0 10px;
                        box-sizing: border-box;
                        cursor: pointer;
                      

                       }
                    }
                .video-list{
                    background-color: #000000 !important;
                }

            }
        }
    }
}
.dialog-footer-btn1 {
    // padding: 12px 20px;
    width: 96px !important;
    height: 38px ;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #B0B0BA;
}
.dialog-footer-btn{
    // padding: 12px 20px;
    width: 96px !important;
    height: 38px ;
    background: #006EFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #006EFF;
}
.content {
                    width: 100%;
                    display: flex;
                    height: 500px;
                    // flex: 1;
                    // height: 1%;
                    padding: 13px;
                    margin-top: 10px;

                    .left-list {
                        // background-color: pink;
                        width: 240px;
                        height: 100%;
                        background-color: #FFFFFF;
                        margin-left: -13px;
                        

                        ::v-deep .el-scrollbar__wrap {
                            overflow-x: hidden;

                            .el-scrollbar__view {
                                height: 100%;
                            }
                        }

                        .type-item {
                            width: 94%;
                            margin-bottom: 10px;
                            height: 34px;
                            line-height: 34px;
                            // padding-left: 10px;
                            color: #333;
                            font-size: 14px;
                            cursor: pointer;
                            // background-color: pink;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                         
                            // overflow: hidden;
                            // text-overflow: ellipsis;
                            // white-space: nowrap;
                            // border: 1px solid #DDDDDD;

                            
                            .type_name{
                                width: 180px;
                                // background-color: skyblue;
                                height: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                border: 1px solid #DDDDDD;
                                padding-left: 8px;
                                box-sizing: border-box;
                                border-radius: 4px;
                                &:hover {
                                background-color: #ECF5FF;
                                // color: #409EFF;
                            }
                            }
                            .add_icon{
                                margin-left: 10px;
                            }
                            .current {
                                background: #ECF5FF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #006EFF;
                        }
                        }

                        
                    }

                    .right-list {
                        // 展示
                        flex: 1;
                        width: 0%;
                        // margin: 22px 22px 22px 35px;
                        margin-right: 14px;
                        box-sizing: border-box;
                        background: #F2F6FA;
                        border-radius: 4px;
                        position: relative;
                      div{
                        width: 100%;
                        height: 100%;
                        .avi-box{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                       }
                       .download_box{
                        width: 100%;
                        height: 100%;
                     
                        border: 10px soild #999999;
                        border-radius: 4px;
                     
                        display: flex;
                        align-items: center;
                        justify-content:center;
                        flex-direction: column;
                       }
                      }
                        // display: flex;
                        // align-items: center;
                        /*background-color: rebeccapurple;*/

                        .quanping{
                        width: 66px;
                        height: 28px;
                        background: rgba(0,0,0,0.5);
                        border-radius: 4px 4px 4px 4px;
                        position: absolute;
                        bottom: -3px;
                        right: 20px;
                        display: flex;
                        align-items: center;
                        color: #FFFFFF;
                        justify-content:space-between;
                        padding: 0 10px;
                        box-sizing: border-box;
                        cursor: pointer;
                      

                       }
                    }
                    .video-list{
                    background-color: #000000 !important;
                }

                }



</style>
<style>
.peit_popver{
    min-width: 50px;
 
    display: flex;
    align-items: center;
}
</style>
